import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { createPortal } from 'react-dom';
import { makeStyles } from 'tss-react/mui';

interface Props {
    children: React.ReactNode;
    props?: any;
}

// TODO: this component doesnt correctly pass the theme of the parent to the iframe, making text and font look weird

export default function EmailFrame({ children, ...props }: Props) {
    const { classes } = useStyles();
    const [contentRef, setContentRef] = React.useState<HTMLIFrameElement | null>(null);
    const mountNode = contentRef?.contentWindow?.document?.body;

    return (
        <iframe {...props} ref={setContentRef} className={classes.frame}>
            {mountNode && createPortal(children, mountNode)}
        </iframe>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    frame: {
        border: 'none',
        height: '100%',
        width: '100%',
        fontFamily: 'Roboto',
        overflowY: 'hidden',
    },
}));

// function FramedDemo(props:FrameProps ) {
//   const { children, document } = props;

//   const theme = useTheme();
//   React.useEffect(() => {
//     document.body.dir = theme.direction;
//   }, [document, theme.direction]);

//   const { jss, sheetsManager } = React.useMemo(() => {
//     return {
//       jss: create({
//         plugins: [...jssPreset().plugins, rtl()],
//         insertionPoint: document.head,
//       }),
//       sheetsManager: new Map(),
//     };
//   }, [document]);

//   const cache = React.useMemo(
//     () =>
//       createCache({
//         key: `iframe-demo-${theme.direction}`,
//         prepend: true,
//         container: document.head,
//         stylisPlugins: theme.direction === 'rtl' ? [rtlPlugin] : [],
//       }),
//     [document, theme.direction],
//   );

//   const getWindow = React.useCallback(() => document.defaultView, [document]);

//   return (
//     <StylesProvider jss={jss} sheetsManager={sheetsManager}>
//           {React.cloneElement(children, {
//             window: getWindow,
//           })}
//     </StylesProvider>
//   );
// }
// interface FrameProps {
//   children: any,
//   document: PropTypes.object.isRequired,
// };
